

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   FormControl,
//   FormLabel,
//   Input,
//   InputGroup,
//   InputRightElement,
//   Stack,
//   useToast,
// } from '@chakra-ui/react';
// import axios from 'axios';

// const Item = () => {
//   const [newFormData, setNewFormData] = useState({
//     name: '',
//     email: '',
//     password: '',
//     confirmPassword: '',
//     nationalId: '',
//     profileImage: null,
//     idImage: null,
//     phoneNumber: '',
//     birthdate: '',
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const toast = useToast();

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files) {
//       setNewFormData({ ...newFormData, [name]: files[0] });
//     } else {
//       setNewFormData({ ...newFormData, [name]: value });
//     }
//   };

//   const validateForm = () => {
//     const {
//       name,
//       email,
//       password,
//       confirmPassword,
//       nationalId,
//       profileImage,
//       idImage,
//       phoneNumber,
//       birthdate,
//     } = newFormData;

//     if (!name || !email || !password || !confirmPassword || !nationalId || !profileImage || !idImage || !phoneNumber || !birthdate) {
//       toast({
//         title: 'Validation Error',
//         description: 'All fields are required.',
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//       return false;
//     }

//     if (password !== confirmPassword) {
//       toast({
//         title: 'Validation Error',
//         description: 'Passwords do not match.',
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     const formData = new FormData();
//     for (const key in newFormData) {
//       formData.append(key, newFormData[key]);
//     }

//     try {
//       const response = await axios.post('https://api.example.com/register', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       toast({
//         title: 'Registration Successful',
//         description: response.data.message,
//         status: 'success',
//         duration: 5000,
//         isClosable: true,
//       });
//     } catch (error) {
//       toast({
//         title: 'Registration Failed',
//         description: error.response?.data?.message || error.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   };

//   return (
//     <Box maxW="md" mx="auto" mt={10}>
//       <form onSubmit={handleSubmit}>
//         <Stack spacing={4}>
//           <FormControl id="name" isRequired>
//             <FormLabel>Name</FormLabel>
//             <Input type="text" name="name" value={newFormData.name} onChange={handleChange} />
//           </FormControl>

//           <FormControl id="email" isRequired>
//             <FormLabel>Email</FormLabel>
//             <Input type="email" name="email" value={newFormData.email} onChange={handleChange} />
//           </FormControl>

//           <FormControl id="password" isRequired>
//             <FormLabel>Password</FormLabel>
//             <InputGroup>
//               <Input
//                 type={showPassword ? 'text' : 'password'}
//                 name="password"
//                 value={newFormData.password}
//                 onChange={handleChange}
//               />
//               <InputRightElement width="4.5rem">
//                 <Button h="1.75rem" size="sm" onClick={() => setShowPassword(!showPassword)}>
//                   {showPassword ? 'Hide' : 'Show'}
//                 </Button>
//               </InputRightElement>
//             </InputGroup>
//           </FormControl>

//           <FormControl id="confirmPassword" isRequired>
//             <FormLabel>Confirm Password</FormLabel>
//             <Input
//               type={showPassword ? 'text' : 'password'}
//               name="confirmPassword"
//               value={newFormData.confirmPassword}
//               onChange={handleChange}
//             />
//           </FormControl>

//           <FormControl id="nationalId" isRequired>
//             <FormLabel>National ID</FormLabel>
//             <Input type="text" name="nationalId" value={newFormData.nationalId} onChange={handleChange} />
//           </FormControl>

//           <FormControl id="profileImage" isRequired>
//             <FormLabel>Profile Image</FormLabel>
//             <Input type="file" name="profileImage" onChange={handleChange} />
//           </FormControl>

//           <FormControl id="idImage" isRequired>
//             <FormLabel>ID Image</FormLabel>
//             <Input type="file" name="idImage" onChange={handleChange} />
//           </FormControl>

//           <FormControl id="phoneNumber" isRequired>
//             <FormLabel>Phone Number</FormLabel>
//             <Input type="tel" name="phoneNumber" value={newFormData.phoneNumber} onChange={handleChange} />
//           </FormControl>

//           <FormControl id="birthdate" isRequired>
//             <FormLabel>Birthdate</FormLabel>
//             <Input type="date" name="birthdate" value={newFormData.birthdate} onChange={handleChange} />
//           </FormControl>

//           <Button type="submit" colorScheme="teal" size="lg" mt={4}>
//             Register
//           </Button>
//         </Stack>
//       </form>
//     </Box>
//   );
// };

// export default Item;



// // const saveTokenToServer = async (userId, token) => {
// //   try {
// //     const response = await fetch('/api/save-token', {
// //       method: 'POST',
// //       headers: {
// //         'Content-Type': 'application/json',
// //       },
// //       body: JSON.stringify({ userId, token }),
// //     });
// //     const data = await response.json();
// //     console.log('Token saved successfully:', data);
// //   } catch (error) {
// //     console.error('Error saving token:', error);
// //   }
// // };

// export default App;






// import React, { useEffect, useState, useRef } from 'react';
// import { useParams } from 'react-router-dom';
// import { io } from 'socket.io-client';
// import { Box, Flex, Spinner, Image, Text, Heading, Stack, Alert, AlertIcon, Grid, GridItem, Container, Badge } from '@chakra-ui/react';
// import Api from '../api/ApiUrl';

// const SOCKET_URL = `${Api}/auctiondetails`;
// const socket = io(SOCKET_URL, {
//   autoConnect: false
// });

// const AuctionComponent = () => {
//   const { id: subcategoryId } = useParams();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [timeLeft, setTimeLeft] = useState('');

//   const timerRef = useRef(null);

//   const calculateTimeLeft = (endDate) => {
//     const now = new Date().getTime();
//     const endTime = new Date(endDate).getTime();
//     const timeRemaining = endTime - now;

//     const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

//     setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
//   };

//   useEffect(() => {
//     socket.on('connect', () => {
//       socket.emit('getSubcategoryData', { subcategoryId: "6683b5d5b203cb37871d1de8" });
//     });

//     socket.on('subCategoryDatachanged', (data) => {
//       console.log('subCategoryDatachanged')
//       socket.emit('getSubcategoryData', { subcategoryId: "6683b5d5b203cb37871d1de8" });

//     });


//     socket.on('auctionData', (data) => {
//       setData(data);
//       setLoading(false);

//       calculateTimeLeft(data.endDate);

//       timerRef.current = setInterval(() => {
//         calculateTimeLeft(data.endDate);
//       }, 1000);
//     });

//     socket.on('error', (error) => {
//       setError(error);
//       setLoading(false);
//     });

//     socket.connect();

//     return () => {
//       socket.disconnect();
//       clearInterval(timerRef.current);
//     };
//   }, [subcategoryId]);

//   if (loading) {
//     return <Flex justify="center" align="center" height="100vh" bg="gray.800" color="white"><Spinner size="xl" /></Flex>;
//   }

//   if (error) {
//     return <Alert status="error" bg="red.700" color="white"><AlertIcon />{error.message || 'Error loading data'}</Alert>;
//   }

//   if (!data) {
//     return <Alert status="warning" bg="yellow.700" color="white"><AlertIcon />No data available</Alert>;
//   }

//   return (
//     <Box color="black" minHeight="100vh" py={10} position="relative" >
//       <Box position="absolute" top="40%" left="55%" transform="translate(-50%, -50%)" opacity="0.1" fontSize="10rem" fontWeight="bold" zIndex={0}>
//         <Text as="span" color="red">Mazadat</Text><Text as="span" color="black"> Masr</Text>
//       </Box>
//       <Container maxW="container.xl" zIndex={1}>
//         <Heading as="h1" mb={8} textAlign="center" color="teal.300">Auction Details</Heading>
//         <Box mb={8} p={5} shadow="md" borderWidth="1px" borderRadius="lg" >
//           <Image src={`${Api}/${data.imagecover.path}`} alt={data.name} borderRadius="md" />
//           <Text fontSize="2xl" mt={4} color="teal.200">{data.name}</Text>
//           <Text mt={2}>{data.description}</Text>
//           <Text mt={2}>Start Date: {new Date(data.startDate).toLocaleString()}</Text>
//           <Text mt={2}>End Date: {new Date(data.endDate).toLocaleString()}</Text>
//           <Text mt={2}>Total Bid Count: {data.totalBidCount}</Text>
//           <Text mt={2}>Total Deposit Users Count: {data.totalDepositUsersCount}</Text>
//           <Text mt={2}>Total Bid Users Count: {data.totalBidUsersCount}</Text>
//           <Text mt={2}>Time Remaining: {timeLeft}</Text>
//         </Box>
//         <Heading as="h2" mb={4} textAlign="center" color="teal.300">Items</Heading>
//         <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={6}>
//           {data.items.map(item => (
//             <GridItem key={item._id}>
//               <Box borderWidth="1px" borderRadius="lg" overflow="hidden" p={6} shadow="md" >
//                 <Image src={`${Api}/${item.coverphoto.path}`} alt={item.name} borderRadius="md" />
//                 <Stack spacing={3} mt={3}>
//                   <Heading size="md" color="teal.200">{item.name}</Heading>
//                   <Text>{item.description}</Text>
//                   <Text>Start Price: ${item.startPrice}</Text>
//                   <Text>Min Bid Increment: ${item.minBidIncrement}</Text>
//                   <Badge colorScheme={item.status === 'active' ? 'green' : 'red'}>{item.status}</Badge>
//                   <Text>Bid Count: {item.bidCount}</Text>
//                   <Text>Bid User Count: {item.bidUserCount}</Text>
//                   <Text>Highest Bid: ${item.highestBid}</Text>
//                   {item.lastBid && (
//                     <Box>
//                       <Text>Last Bid: ${item.lastBid.amount}</Text>
//                       <Text>Last Bid User: {item.lastBid.user.name}</Text>
//                       <Text>Last Bid User Phone: {item.lastBid.user.phoneNumber}</Text>
//                     </Box>
//                   )}
//                 </Stack>
//               </Box>
//             </GridItem>
//           ))}
//         </Grid>
//       </Container>
//     </Box>
//   );
// };

// export default AuctionComponent;









// import React, { useState } from 'react';
// import axios from 'axios';
// import {
//   Box,
//   Button,
//   Heading,
//   Text,
//   VStack,
//   HStack,
//   useToast,
//   StackDivider
// } from '@chakra-ui/react';

// function Item() {
//   const [orderId, setOrderId] = useState('');
//   const [message, setMessage] = useState('');
//   const [a, seta] = useState('');

//   const tamaraApiUrl = 'https://api-sandbox.tamara.co'; // Use the Tamara sandbox environment
//   const authorization= 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhY2NvdW50SWQiOiI1YTBhYTUwMS1mNzNkLTQ2ZTgtYTExNi0wODdkNjk0YTE1YzUiLCJ0eXBlIjoibWVyY2hhbnQiLCJzYWx0IjoiMDFmMzBiZDM2OTRhZDI3YjU3ZWEyMmJmZTgwYWRmOWMiLCJyb2xlcyI6WyJST0xFX01FUkNIQU5UIl0sImlhdCI6MTcyNDc0NDI1NiwiaXNzIjoiVGFtYXJhIn0.nGyvapPTT6cry_nd1aEO-IEWWbUWs4mELgKcIMefHXf7qDh2CEW6eW137wgIa7PcEPpNG_Ij_OslSI-4G-Ab3ozL-_rR3-kK86DP2IPAoNHOeopaovv95FioFZk8zVAIALnf68iKiKXPrgzikq7v8ZnzGo97V-yLmzup5FyrTKBd9fp5_rOUYm26mrVWAghNNfU5YK18akEgsRsI5NuDAKdion0tbZ7dF_pGrpa3lidY1O1SgfMgcbCXbAQVEtIxfLo0XCt4q5fw9tCPyRIO2evrqxfJ7AHZFNhbyqVMVbpnXYWD20UarnCDHrAEhV4myCz2kcRhsPq_uMQ2QQbOBw' // 
//   const toast = useToast();

//   const createProduct = async () => {
//     const productData = JSON.stringify(
//       // Product details...
//       {
//         total_amount: {amount: 300, currency: 'SAR'},
//         shipping_amount: {amount: 1, currency: 'SAR'},
//         tax_amount: {amount: 1, currency: 'SAR'},
//         order_reference_id: 'abd12331-a123-1234-4567-fbde34ae',
//         order_number: 'A123125',
//         discount: {name: 'Voucher A', amount: {amount: 0, currency: 'SAR'}},
//         items: [
//           {
//             name: 'Lego City 8601',
//             type: 'Digital',
//             reference_id: '123',
//             sku: 'SA-12436',
//             quantity: 1,
//             discount_amount: {amount: 100, currency: 'SAR'},
//             tax_amount: {amount: 10, currency: 'SAR'},
//             unit_price: {amount: 490, currency: 'SAR'},
//             total_amount: {amount: 100, currency: 'SAR'}
//           }
//         ],
//         consumer: {
//           email: 'customer@email.com',
//           first_name: 'Mona',
//           last_name: 'Lisa',
//           phone_number: '566027755'
//         },
//         country_code: 'SA',
//         description: 'Enter order description here.',
//         merchant_url: {
//           cancel: 'http://example.com/#/cancel',
//           failure: 'http://example.com/#/fail',
//           success: 'http://example.com/#/success',
//           notification: 'https://example-notification.com/payments/tamaranotifications'
//         },
//         payment_type: 'PAY_BY_INSTALMENTS',
//         instalments: 3,
//         billing_address: {
//           city: 'Riyadh',
//           country_code: 'SA',
//           first_name: 'Mona',
//           last_name: 'Lisa',
//           line1: '3764 Al Urubah Rd',
//           line2: 'string',
//           phone_number: '532298658',
//           region: 'As Sulimaniyah'
//         },
//         shipping_address: {
//           city: 'Riyadh',
//           country_code: 'SA',
//           first_name: 'Mona',
//           last_name: 'Lisa',
//           line1: '3764 Al Urubah Rd',
//           line2: 'string',
//           phone_number: '532298658',
//           region: 'As Sulimaniyah'
//         },
//         platform: 'platform name here',
//         is_mobile: false,
//         locale: 'ar_SA',
//         risk_assessment: {
//           customer_age: 21,
//           customer_dob: '01-12-2000',
//           customer_gender: 'Female',
//           customer_nationality: 'SA',
//           is_premium_customer: false,
//           is_existing_customer: false,
//           is_guest_user: false,
//           account_creation_date: '12-06-2020',
//           platform_account_creation_date: '12-06-2020',
//           date_of_first_transaction: '12-06-2020',
//           is_card_on_file: false,
//           is_COD_customer: false,
//           has_delivered_order: true,
//           is_phone_verified: false,
//           is_fraudulent_customer: false,
//           total_ltv: 200,
//           total_order_count: 15,
//           order_amount_last3months: 2000,
//           order_count_last3months: 10,
//           last_order_date: '12-06-2020',
//           last_order_amount: 2000,
//           reward_program_enrolled: false,
//           reward_program_points: 2000
//         },
//         additional_data: {
//           delivery_method: 'Home Delivery',
//           pickup_store: 'Store A',
//           store_code: 'Branch A',
//           vendor_amount: 0,
//           merchant_settlement_amount: 0,
//           vendor_reference_code: 'AZ1234'
//         }});

//     try {
//       const response = await axios.post(
//         `${tamaraApiUrl}/checkout`,
//         productData,
//         { headers: { Authorization: authorization, 'Content-Type': 'application/json' } }
//       );
//       setOrderId(response.data.order_id);
//       console.log(response.data);
//       seta(response?.data?.checkout_url      )
//       setMessage('Product created and payment initiated!');
//       toast({
//         title: 'Product created.',
//         description: 'Payment initiated successfully!',
//         status: 'success',
//         duration: 5000,
//         isClosable: true
//       });
//     } catch (error) {
//       console.error(error);
//       setMessage('Error creating product');
//       toast({
//         title: 'Error',
//         description: 'There was an error creating the product',
//         status: 'error',
//         duration: 5000,
//         isClosable: true
//       });
//     }
//   };

//   const refundOrder = async () => {
//     try {
//       await axios.post(
//         `${tamaraApiUrl}/payments/simplified-refund/${orderId}`,
//         JSON.stringify({
//           total_amount: { amount: 300, currency: 'SAR' },
//           comment: 'Refund for Lego City'
//         }),
//         { headers: { Authorization: authorization, 'Content-Type': 'application/json' } }
//       );
//       setMessage('Order refunded successfully!');
//       toast({
//         title: 'Order refunded.',
//         description: 'Refund has been processed.',
//         status: 'success',
//         duration: 5000,
//         isClosable: true
//       });
//     } catch (error) {
//       console.error(error);
//       setMessage('Error refunding order');
//       toast({
//         title: 'Error',
//         description: 'There was an error refunding the order.',
//         status: 'error',
//         duration: 5000,
//         isClosable: true
//       });
//     }
//   };

//   const cancelOrder = async () => {
//     try {
//       await axios.post(
//         `${tamaraApiUrl}/orders/${orderId}/cancel`,
//         JSON.stringify({
//           total_amount: { amount: 300, currency: 'SAR' },
//           comment: 'Cancel for Lego City'
//         }),
//         { headers: { Authorization: authorization, 'Content-Type': 'application/json' } }
//       );
//       setMessage('Order canceled successfully!');
//       toast({
//         title: 'Order canceled.',
//         description: 'Order has been successfully canceled.',
//         status: 'success',
//         duration: 5000,
//         isClosable: true
//       });
//     } catch (error) {
//       console.error(error);
//       setMessage('Error canceling order');
//       toast({
//         title: 'Error',
//         description: 'There was an error canceling the order.',
//         status: 'error',
//         duration: 5000,
//         isClosable: true
//       });
//     }
//   };
//   const authorizeOrder = async () => {
//     try {
//       // Post to the authorize endpoint with the correct payload
//       const response = await axios.post(
//         `${tamaraApiUrl}/orders/${orderId}/authorise`,  // Replace with your actual orderId
//         {
//           order_id: orderId // Send the order ID in the body
//         },
//         {
//           headers: {
//             Authorization: `${authorization}`,  // Ensure authorization header contains 'Bearer'
//             'Content-Type': 'application/json'
//           }
//         }
//       );
  
//       // Success message and toast notification
//       setMessage('Order authorized successfully!');
//       toast({
//         title: 'Order authorized.',
//         description: 'Order has been authorized successfully!',
//         status: 'success',
//         duration: 5000,
//         isClosable: true,
//       });
  
//       console.log(response.data); // Log the response data
//     } catch (error) {
//       // Error handling
//       console.error('Error authorizing order:', error.response?.data || error.message);
      
//       setMessage('Error authorizing order');
//       toast({
//         title: 'Error',
//         description: 'There was an error authorizing the order.',
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   };
//   const captureOrder = async () => {
//     try {
//       const captureData = JSON.stringify({
//         order_id: orderId,
//         total_amount: {amount: 300, currency: 'SAR'},
//         shipping_info: {
//           shipped_at: '2020-03-31T19:19:52.677Z',
//           shipping_company: 'DHL',
//           tracking_number: '100',
//           tracking_url: 'https://shipping.com/tracking?id=123456'
//         },
//         items: [
//           {
//             name: 'Lego City 8601',
//             type: 'Digital',
//             reference_id: 'abd12331-a123-1234-4567-fbde34ae',
//             sku: 'SA-12436',
//             quantity: 1,
//             discount_amount: {amount: 100, currency: 'SAR'},
//             tax_amount: {amount: 10, currency: 'SAR'},
//             unit_price: {amount: 490, currency: 'SAR'},
//             total_amount: {amount: 100, currency: 'SAR'}
//           }
//         ],
//         discount_amount: {amount: 0, currency: 'SAR'},
//         shipping_amount: {amount: 0, currency: 'SAR'},
//         tax_amount: {amount: 100, currency: 'SAR'}
//       })

//       const response = await axios.post(
//         `${tamaraApiUrl}/payments/capture`,
//         captureData,
//         { headers: { Authorization: authorization, 'Content-Type': 'application/json' } }
//       );

//       setMessage('Order captured successfully!');
//       toast({
//         title: 'Order captured.',
//         description: 'The payment has been captured successfully!',
//         status: 'success',
//         duration: 5000,
//         isClosable: true
//       });
//     } catch (error) {
//       console.error(error);
//       setMessage('Error capturing the order');
//       toast({
//         title: 'Error',
//         description: 'There was an error capturing the order',
//         status: 'error',
//         duration: 5000,
//         isClosable: true
//       });
//     }
//   };
//   const getOrderDetails = async () => {
//     try {
//       const response = await axios.get(`${tamaraApiUrl}/orders/${orderId}`, {
//         headers: { Authorization: authorization }
//       });
//       setMessage(`Order details: ${JSON.stringify(response.data)}`);
//     } catch (error) {
//       console.error(error);
//       setMessage('Error fetching order details');
//     }
//   };

//   return (
//     <Box p={8} maxWidth="600px" mx="auto">
//       <a>{a}</a>
//       <VStack spacing={6} divider={<StackDivider borderColor="gray.200" />}>
//         <Heading as="h1" size="xl" textAlign="center">
//           Tamara E-Commerce
//         </Heading>

//         <HStack spacing={4}>
//           <Button colorScheme="teal" onClick={createProduct}>
//             Create Product & Pay
//           </Button>
//           <Button
//             colorScheme="orange"
//             onClick={captureOrder}
//             disabled={!orderId}
//           >
//             Capture Order
//           </Button>
//           <Button
//             colorScheme="orange"
//             onClick={refundOrder}
//             disabled={!orderId}
//           >
//             Refund Order
//           </Button>
//         </HStack>
//         <Button
//   colorScheme="green"
//   onClick={authorizeOrder}
//   disabled={!orderId}
// >
//   Authorize Order
// </Button>

//         <HStack spacing={4}>
//           <Button
//             colorScheme="red"
//             onClick={cancelOrder}
//             disabled={!orderId}
//           >
//             Cancel Order
//           </Button>
//           <Button
//             colorScheme="blue"
//             onClick={getOrderDetails}
//             disabled={!orderId}
//           >
//             Get Order Details
//           </Button>
//         </HStack>

//         <Text color="gray.600">{message}</Text>
//       </VStack>
//     </Box>
//   );
// }

// export default Item;





// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   Box,
//   Text,
//   Heading,
//   Button,
//   VStack,
//   HStack,
//   Divider,
//   useToast,
//   Image,
//   Stack,
//   Flex,
// } from '@chakra-ui/react';
// import html2pdf from 'html2pdf.js';
// import logo from '../assets/eba836181a8bb389cc40f37585eec6ae.png';

// const Item = ({ subcategoryId }) => {
//   const [billData, setBillData] = useState([]);
//   const toast = useToast();
//   useEffect(() => {
//     axios
//       .get(
//         `http://localhost:9000/api/v1/mylots/a/66dfe012e7dfbeb6d486c6cc?status=winner`
//       )
//       .then((response) => {
//         if (response.data.status === 'success') {
//           setBillData(response.data.itemDetails);
//         }
//       })
//       .catch((error) => {
//         console.error('Error fetching bills', error);
//         toast({
//           title: 'Error',
//           description: 'Failed to fetch bills.',
//           status: 'error',
//           duration: 5000,
//           isClosable: true,
//         });
//       });
//   }, [subcategoryId, toast]);
// console.log(billData);
//   const downloadBill = (bill) => {
//     const element = document.getElementById(`bill-${bill.subcategoryId}`);
//     const opt = {
//       margin: 0,
//       filename: `bill-${bill.subcategoryId}.pdf`,
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
//     };

//     // Hide buttons before generating PDF
//     const buttons = document.getElementsByClassName('no-print');
//     for (let i = 0; i < buttons.length; i++) {
//       buttons[i].style.display = 'none';
//     }

//     html2pdf()
//       .from(element)
//       .set(opt)
//       .save()
//       .then(() => {
//         // Show buttons again after PDF is generated
//         for (let i = 0; i < buttons.length; i++) {
//           buttons[i].style.display = 'block';
//         }
//       });
//   };

//   const printBill = (bill) => {
//     const element = document.getElementById(`bill-${bill.subcategoryId}`);
//     const newWindow = window.open();
//     newWindow.document.write(element.outerHTML);
//     newWindow.print();
//     newWindow.close();
//   };

//   return (
//     <Box position="relative" maxW="1000px" mx="auto" p={5}>
//       {billData.map((bill, index) => (
//         <Box
//           key={index}
//           id={`bill-${bill.subcategoryId}`}
//           borderWidth="1px"
//           borderRadius="lg"
//           p={6}
//           mb={8}
//           boxShadow="xl"
//           bg="white"
//           position="relative"
//         >
//           {/* Background Text */}
//           <Text
//             fontSize="150px"
//             fontWeight="bold"
//             color="blackAlpha.200"
//             position="absolute"
//             top="50%"
//             left="50%"
//             transform="translate(-50%, -50%)"
//             zIndex={-1}
//             opacity={0.1}
//           >
//             Mazadat Masr
//           </Text>

//           {/* Logo */}
//           <Box textAlign="center" mb={10}>
//             <Image
//               src={logo} // Replace with your logo URL
//               alt="Mazadat Masr Logo"
//               width="100px"
//               mb={5}
//             />
//             <Heading as="h1" size="md" color="red.500">
//               Mazadat Masr
//             </Heading>
//           </Box>

//           <VStack align="start" spacing={4}>
//             <Heading as="h3" size="md" color="gray.800">
//               Subcategory: {bill.subcategoryName}
//             </Heading>

//             <Text>
//               <strong>User:</strong> {bill.userName}
//             </Text>
//             <Text>
//               <strong>Phone:</strong> {bill.userPhone}
//             </Text>
//             <Text>
//               <strong>Category:</strong> {bill.categoryName}
//             </Text>
//             <Text>
//               <strong>Deposit:</strong> {bill.deposit} EGP
//             </Text>
//             <Text>
//               <strong>Total Amount:</strong> {bill.totalAmount} EGP
//             </Text>
//             <Text>
//               <strong>Payed:</strong> {bill.payed ? 'Yes' : 'No'}
//             </Text>

//             <Divider />

//             <Heading as="h3" size="sm">
//               Items:
//             </Heading>

//             {bill.items.map((item, idx) => (
//               <Box
//                 key={idx}
//                 borderWidth="1px"
//                 borderRadius="md"
//                 p={4}
//                 w="100%"
//                 bg="gray.50"
//               >
//                 <HStack spacing={4} align="flex-start">
//                   <Image
//                     src={`http://localhost:9000/${item.item.coverphoto.path}`}
//                     alt={item.item.name}
//                     boxSize="100px"
//                     objectFit="cover"
//                     borderRadius="md"
//                   />
//                   <VStack align="start" spacing={2}>
//                     <Text fontSize="lg">
//                       <strong>Item Name:</strong> {item.item.name}
//                     </Text>
//                     <Text>
//                       <strong>Amount:</strong> {item.amount} EGP
//                     </Text>
//                     <Text>
//                       <strong>total amount :</strong> {item.totalPaid} EGP
//                     </Text>
//                     <Text>
//                       <strong>Status:</strong> {item.status}
//                     </Text>
//                     <Text>
//                       <strong>Commissions:</strong>{' '}
//                       {item.commission1 + item.commission2 + item.commission3}{' '}
//                       EGP
//                     </Text>
//                   </VStack>
//                 </HStack>
//               </Box>
//             ))}

//             {/* Buttons (hidden in PDF) */}
//             <HStack spacing={4} className="no-print">
//               <Button
//                 colorScheme="blue"
//                 onClick={() => downloadBill(bill)}
//                 size="sm"
//               >
//                 Download as PDF
//               </Button>
//               <Button
//                 colorScheme="green"
//                 onClick={() => printBill(bill)}
//                 size="sm"
//               >
//                 Print
//               </Button>
//             </HStack>
//           </VStack>
//         </Box>
//       ))}
//     </Box>


//   );
// };

// export default Item;

























/////////////////////////////pdf

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import {
//   Box,
//   Text,
//   Heading,
//   Button,
//   VStack,
//   HStack,
//   Divider,
//   useToast,
//   Image,
// } from '@chakra-ui/react';
// import html2pdf from 'html2pdf.js';
// import logo from '../assets/eba836181a8bb389cc40f37585eec6ae.png';

// const Item = () => {
//   const [billData, setBillData] = useState([]);
//   const toast = useToast();

//   useEffect(() => {
//     axios
//       .get('http://localhost:9000/api/v1/mylots/a/66dfe012e7dfbeb6d486c6cc?status=winner')
//       .then((response) => {
//         if (response.data.status === 'success') {
//           setBillData(response.data.itemDetails);
//         }
//       })
//       .catch((error) => {
//         console.error('Error fetching bills', error);
//         toast({
//           title: 'Error',
//           description: 'فشل في جلب الفواتير.',
//           status: 'error',
//           duration: 5000,
//           isClosable: true,
//         });
//       });
//   }, [toast]);

//   const downloadBill = (bill) => {
//     const element = document.getElementById(`bill-${bill.subcategoryId}`);
//     const opt = {
//       margin: 0,
//       filename: `bill-${bill.subcategoryId}.pdf`,
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
//     };

//     // Hide buttons before generating PDF
//     const buttons = document.getElementsByClassName('no-print');
//     for (let i = 0; i < buttons.length; i++) {
//       buttons[i].style.display = 'none';
//     }

//     html2pdf()
//       .from(element)
//       .set(opt)
//       .save()
//       .then(() => {
//         // Show buttons again after PDF is generated
//         for (let i = 0; i < buttons.length; i++) {
//           buttons[i].style.display = 'block';
//         }
//       });
//   };

//   const printBill = (bill) => {
//     const element = document.getElementById(`bill-${bill.subcategoryId}`);
//     const newWindow = window.open();
//     newWindow.document.write(element.outerHTML);
//     newWindow.print();
//     newWindow.close();
//   };

//   const calculateTotalBeforeDeposit = (items) => {
//     return items.reduce((total, item) => total + item.totalPaid, 0);
//   };
//   const calculateTotalBeforeCommisson = (items) => {
//     return items.reduce((total, item) => total + item.item.startPrice, 0);
//   };
//   return (
//     <Box
//       position="relative"
//       maxW="1000px"
//       mx="auto"
//       p={5}
//       direction="rtl"
//     >
//       {billData.map((bill, index) => (
//         <Box
//           key={index}
//           id={`bill-${bill.subcategoryId}`}
//           borderWidth="1px"
//           borderRadius="lg"
//           p={6}
//           mb={8}
//           boxShadow="xl"
//           bg="white"
//           position="relative"
//         >
//           {/* Background Text */}
//           <Text
//             fontSize="150px"
//             fontWeight="bold"
//             color="blackAlpha.200"
//             position="absolute"
//             top="50%"
//             left="50%"
//             transform="translate(-50%, -50%)"
//             zIndex={-1}
//             opacity={0.1}
//             textAlign="center"
//           >
//             مزادات مصر
//           </Text>

//           {/* Logo */}
//           <Box textAlign="center" mb={10}>
//             <Image
//               src={logo} // Replace with your logo URL
//               alt="شعار مزادات مصر"
//               width="100px"
//               mb={5}
//             />
//             <Heading as="h1" size="md" color="red.500">
//               مزادات مصر
//             </Heading>
//           </Box>

//           <VStack align="end" spacing={4}>
//             <Heading as="h3" size="md" color="gray.800">
//         المزاد تابع الى : {bill.subcategoryName}
//             </Heading>

//             <Text>
//             {bill.userName} <strong>: المستخدم</strong> 
//             </Text>
//             <Text>
//               <strong>الهاتف:</strong> {bill.userPhone}
//             </Text>
//             <Text>
//                {bill.categoryName} <strong>: التصنيف</strong>
//             </Text>
//             <Text>
//               <strong>التامين:</strong> {bill.deposit} ج.م
//             </Text>
//             <Text>
//               <strong>إجمالي المبلغ قبل اضافة العمولات:</strong> {calculateTotalBeforeCommisson(bill.items)} ج.م
//             </Text>
//             <Text>
//               <strong>إجمالي المبلغ قبل خصم التامين:</strong> {calculateTotalBeforeDeposit(bill.items)} ج.م
//             </Text>
//             <Text>
//               <strong>إجمالي المبلغ بعد خصم التامين:</strong> {bill.totalAmount} ج.م
//             </Text>
//             <Text>
//               <strong>مدفوع:</strong> {bill.payed ? 'نعم' : 'لا'}
//             </Text>

//             <Divider />

//             <Heading as="h3" size="sm">
//             : اللوطات 
//             </Heading>

//             {bill.items.map((item, idx) => (
//               <Box
//                 key={idx}
//                 borderWidth="1px"
//                 borderRadius="md"
//                 p={4}
//                 w="100%"
//                 bg="gray.50"
//               >
//                 <HStack spacing={4} align="flex-end">
//                   <Image
//                     src={`http://localhost:9000/${item.item.coverphoto.path}`}
//                     alt={item.item.name}
//                     boxSize="100px"
//                     objectFit="cover"
//                     borderRadius="md"
//                   />
//                   <VStack align="end" spacing={2}>
//                     <Text fontSize="lg">
//                       <strong>اسم اللوط :</strong> {item.item.name}
//                     </Text>
//                     <Text>
//                       <strong>المبلغ:</strong> {item.item.startPrice} ج.م
//                     </Text>
//                     <Text>
//                       <strong>إجمالي المبلغ:</strong> {item.totalPaid} ج.م
//                     </Text>
//                     <Text>
//                       <strong>الحالة:</strong> {item.status}
//                     </Text>
//                     <Text>
//                       <strong>العمولات:</strong>{' '}
//                       {item.commission1 + item.commission2 + item.commission3}{' '}
//                       ج.م
//                     </Text>
//                   </VStack>
//                 </HStack>
//               </Box>
//             ))}

//             {/* Buttons (hidden in PDF) */}
//             <HStack spacing={4} className="no-print" dir="rtl">
//               <Button
//                 colorScheme="blue"
//                 onClick={() => downloadBill(bill)}
//                 size="sm"
//               >
//                 تحميل كملف PDF
//               </Button>
//               <Button
//                 colorScheme="green"
//                 onClick={() => printBill(bill)}
//                 size="sm"
//               >
//                 طباعة
//               </Button>
//             </HStack>
//           </VStack>
//         </Box>
//       ))}
//     </Box>
//   );
// };

// export default Item;
/////////////////////////////////////////////////////////////////


// import React, { useState } from 'react';
// import axios from 'axios';
// import { useEffect } from 'react';

// const Item = () => {
//   const [userId, setUserId] = useState('');
//   const [orderId, setOrderId] = useState('');
//   const [trackingId, setTrackingId] = useState('');
//   const [message, setMessage] = useState('');
//   const [trackingInfo, setTrackingInfo] = useState(null);
//   const [pickupInfo, setPickupInfo] = useState({
//     reference: '',
//     pickup_date: '',
//     time_slot: 'morning',
//     city: '',
//     contact_name: '',
//     contact_phone: '',
//     address: '',
//     shipments: 1
//   });

//   const email = 'Rtmashari.alanazi@gmail.com';
//   const password = 'Mashary@1234';
//   const aymakanUrl = 'https://api.aymakan.net/v2/';

//   // Login to Aymakan to get the API token
//   const loginToAymakan = async () => {
//     try {
//       const response = await axios.post(`${aymakanUrl}login`, {
//         email: email,
//         password: password,
//       });
//       console.log(response)
//       if (response.data.success) {
//         return response.data.user_data.api_token;
//       }
//       return null;
//     } catch (error) {
//       setMessage('Login to Aymakan failed');
//       return null;
//     }
//   };

//   useEffect(()=>{
//     loginToAymakan()
//   },[])
//   // Create a shipping request
//   const createShippingRequest = async (order_id, user_id) => {
//     const apiToken = await loginToAymakan();
//     if (!apiToken) {
//       setMessage('Failed to authenticate with Aymkan');
//       return;
//     }

//     const shippingDetails = {
//       requested_by: 'sold_out',
//       declared_value: 100,
//       declared_value_currency: 'SAR',
//       reference: 'ORD123345',
//       is_cod: 0,
//       cod_amount: 0,
//       currency: 'SAR',
//       delivery_name: 'John Doe',
//       delivery_phone: '0531381115',
//       delivery_city: 'Riyadh',
//       delivery_address: 'Some Address',
//       delivery_neighbourhood: 'Al Sahafa',
//       delivery_postcode: 11543,
//       delivery_country: 'SA',
//       collection_name: 'Sold out',
//       collection_city: 'Riyadh',
//       collection_address: 'Al Sahafa',
//       collection_phone: '0531381115',
//       weight: 38,
//       pieces: 1,
//       items_count: 1,
//       is_insured: 0,
//     };

//     try {
//       const response = await axios.post(`${aymakanUrl}shipping/create`, shippingDetails, {
//         headers: {
//           Authorization: apiToken,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.status === 200) {
//         setMessage('Shipping request created successfully.');
//       } else {
//         setMessage('Shipping request failed.');
//       }
//     } catch (error) {
//       if (error.response && error.response.status === 422) {
//         console.error('Validation error:', error.response.data);
//         setMessage('Shipping request failed: ' + error.response.data.message);
//       } else {
//         console.error('Error:', error.message);
//         setMessage('Error creating shipping request: ' + error.message);
//       }
//     }
//   };

//   // Fetch the tracking info
//   const fetchTrackingInfo = async (trackingId) => {
//     const apiToken = await loginToAymakan();
//     if (!apiToken) {
//       setMessage('Failed to authenticate with Aymkan');
//       return;
//     }

//     try {
//       const response = await axios.get(`${aymakanUrl}shipping/track/${trackingId}`, {
//         headers: {
//           Authorization: apiToken,
//           'Accept': 'application/json',
//         },
//       });

//       if (response.data.success) {
//         setTrackingInfo(response.data.shipping);
//         setMessage('Tracking information retrieved successfully.');
//       } else {
//         setMessage('Failed to retrieve tracking information.');
//       }
//     } catch (error) {
//       setMessage('Error fetching tracking information: ' + error.message);
//     }
//   };

//   // Create pickup request
//   const createPickupRequest = async () => {
//     const apiToken = await loginToAymakan();
//     if (!apiToken) {
//       setMessage('Failed to authenticate with Aymkan');
//       return;
//     }

//     try {
//       const response = await axios.post(`${aymakanUrl}pickup_request/create`, pickupInfo, {
//         headers: {
//           Authorization: apiToken,
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//         },
//       });

//       if (response.status === 200) {
//         setMessage('Pickup request created successfully.');
//       } else {
//         setMessage('Pickup request failed.');
//       }
//     } catch (error) {
//       if (error.response && error.response.status === 422) {
//         console.error('Validation error:', error.response.data);
//         setMessage('Pickup request failed: ' + error.response.data.message);
//       } else {
//         console.error('Error:', error.message);
//         setMessage('Error creating pickup request: ' + error.message);
//       }
//     }
//   };

//   // Handle form change for pickup request
//   const handlePickupChange = (e) => {
//     const { name, value } = e.target;
//     setPickupInfo({ ...pickupInfo, [name]: value });
//   };

//   // Handle the form submit to test shipping process
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     createShippingRequest(orderId, userId);
//   };

//   // Handle the form submit to track shipping
//   const handleTrackSubmit = (e) => {
//     e.preventDefault();
//     fetchTrackingInfo(trackingId);
//   };

//   // Handle the form submit to create pickup request
//   const handlePickupSubmit = (e) => {
//     e.preventDefault();
//     createPickupRequest();
//   };

//   return (
//     <div>
//       <h2>Test Shipping Process</h2>
//       <form onSubmit={handleSubmit}>
//         <div>
//           <label>User ID:</label>
//           <input
//             type="text"
//             value={userId}
//             onChange={(e) => setUserId(e.target.value)}
//             required
//           />
//         </div>
//         <div>
//           <label>Order ID:</label>
//           <input
//             type="text"
//             value={orderId}
//             onChange={(e) => setOrderId(e.target.value)}
//             required
//           />
//         </div>
//         <button type="submit">Submit</button>
//       </form>

//       <h2>Track Shipping</h2>
//       <form onSubmit={handleTrackSubmit}>
//         <div>
//           <label>Tracking ID:</label>
//           <input
//             type="text"
//             value={trackingId}
//             onChange={(e) => setTrackingId(e.target.value)}
//             required
//           />
//         </div>
//         <button type="submit">Track</button>
//       </form>

//       <h2>Create Pickup Request</h2>
//       <form onSubmit={handlePickupSubmit}>
//         <div>
//           <label>Reference:</label>
//           <input
//             type="text"
//             name="reference"
//             value={pickupInfo.reference}
//             onChange={handlePickupChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Pickup Date:</label>
//           <input
//             type="date"
//             name="pickup_date"
//             value={pickupInfo.pickup_date}
//             onChange={handlePickupChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Time Slot:</label>
//           <select
//             name="time_slot"
//             value={pickupInfo.time_slot}
//             onChange={handlePickupChange}
//             required
//           >
//             <option value="morning">Morning</option>
//             <option value="afternoon">Afternoon</option>
//             <option value="evening">Evening</option>
//           </select>
//         </div>
//         <div>
//           <label>City:</label>
//           <input
//             type="text"
//             name="city"
//             value={pickupInfo.city}
//             onChange={handlePickupChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Contact Name:</label>
//           <input
//             type="text"
//             name="contact_name"
//             value={pickupInfo.contact_name}
//             onChange={handlePickupChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Contact Phone:</label>
//           <input
//             type="text"
//             name="contact_phone"
//             value={pickupInfo.contact_phone}
//             onChange={handlePickupChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Address:</label>
//           <input
//             type="text"
//             name="address"
//             value={pickupInfo.address}
//             onChange={handlePickupChange}
//             required
//           />
//         </div>
//         <div>
//           <label>Shipments:</label>
//           <input
//             type="number"
//             name="shipments"
//             value={pickupInfo.shipments}
//             onChange={handlePickupChange}
//             required
//           />
//         </div>
//         <button type="submit">Create Pickup</button>
//       </form>

//       {message && <p>{message}</p>}

//       {trackingInfo && (
//         <div>
//           <h3>Tracking Information</h3>
//           <p>Tracking Number: {trackingInfo.tracking_number}</p>
//           <p>Customer Name: {trackingInfo.customer_name}</p>
//           <p>Delivery Name: {trackingInfo.delivery_name}</p>
//           <p>Delivery Address: {trackingInfo.delivery_address}</p>
//           <p>Delivery City: {trackingInfo.delivery_city}</p>
//           <p>Status: {trackingInfo.status_label}</p>
//           <a href={trackingInfo.pdf_label} target="_blank" rel="noopener noreferrer">Download PDF Label</a>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Item;






import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Item = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email !== "" && password !== "") {
      try {
        const response = await fetch(
          "https://api.mawheba.org/api/users/login/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": "a8k2j7h3pRn4wbL9xs5yo6uc1qe0fzmx",
            },
            body: JSON.stringify({ email, password }),
          }
        );
        const res = await response.json();
        if (res) {
          localStorage.setItem("accessToken", res.data.access);
          localStorage.setItem("refreshToken", res.data.refresh);
          navigate("/Dashboard");
        } else {
          throw new Error(res.message);
        }
      } catch (err) {
        setError(err.message);
        // console.error(err);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div>
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <button type="submit">Login</button>
      {error && <p className="error">{error}</p>}
    </form>
  );
};

export default Item;










// import React, { useEffect, useState } from 'react';
// import Pusher from 'pusher-js';
//  // Assuming you're using a custom auth provider

// const Test = () => {
//   const [driverLocation, setDriverLocation] = useState({ latitude: 0, longitude: 0 });
//   const [passengerLocation, setPassengerLocation] = useState({ latitude: 0, longitude: 0 });
//  // Assuming you get the auth token from here

//   useEffect(() => {
  

//     // Initialize Pusher without subscribing yet
//     const pusher = new Pusher("a5e38fab4a807c0eac56", {
//       cluster: "eu",
//       encrypted: true,
//     });

//     // Bind to the 'connected' event to get the socket_id
//     pusher.connection.bind('connected', async () => {
//       const socketId = pusher.connection.socket_id;
//       try {
//         // Send the socket_id and channel_name in the POST body
//         const response = await fetch('http://dog.addictaco.com/api/v2/auth/pusher', {
//           method: 'POST',
//           headers: {
//             'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2RvZ2RyaXZlLmNvbS8iLCJpc3MiOiJodHRwczovL2RvZ2RyaXZlLmNvbS8iLCJleHAiOjE3Mjc1OTQ5OTAsImlhdCI6MTcyNzU5MTM5MCwibmJmIjoxNzI3NTkxMzkwLCJzdWIiOiIyMThhMDRhYi0zMTcwLTRiOWQtODczZi0zZGE3YzJhZTlkYzQiLCJwX3NlY3QiOiI1MWJhZjU2YjZjY2Q5NjQ3NzJiMDAxNDhmZTFjNTAwZDRkYzFiM2FlOTQ3YTI5MmYyOGQwZmY1NmQxOWJlYmZkIiwicF9jdHlwIjoiQUNTIn0.RzHygYaQDVg5IoQJzxtzLRFF-wvUf2hn_LJb2KZuB0U`,
//             'Content-Type': 'application/json',
//             'x-api-key': 'fab6c94fc0044b53bf5e886a8fef1325', 
//           },
//           body: JSON.stringify({
//             SocketId: socketId, // The socket_id provided by Pusher
//             ChannelName: 'private-ride_e84b72ad-87cd-4f8c-9c7d-1a1d3365a77b', // The channel name
//           }),
//         });
//         if (!response.ok) {
//           throw new Error('Failed to authenticate with Pusher');
//         }
        
//         const data = await response.json();
     

//         // Now subscribe to the channel with proper authentication
//         // const channel = pusher.subscribe('private-ride_e84b72ad-87cd-4f8c-9c7d-1a1d3365a77b');
//         const channel = pusher.subscribe('ride_e84b72ad-87cd-4f8c-9c7d-1a1d3365a77b');

//         channel.bind('driver-location', (data) => {
//           console.log("data",data)
//           setDriverLocation({ latitude: data.latitude, longitude: data.longitude });
//         });

//         channel.bind('passenger-location', (data) => {
//           console.log(data)
//           setPassengerLocation({ latitude: data.latitude, longitude: data.longitude });
//         });

//         return () => {
//           channel.unbind_all();
//           channel.unsubscribe();
//         };

//       } catch (error) {
//         console.error("Pusher authentication failed:", error);
//       }
//     });
//   }, [driverLocation]);

//   return (
//     <div>
//       <h2>Driver Location</h2>
//       <p>Latitude: {driverLocation.latitude}</p>
//       <p>Longitude: {driverLocation.longitude}</p>

//       <h2>Passenger Location</h2>
//       <p>Latitude: {passengerLocation.latitude}</p>
//       <p>Longitude: {passengerLocation.longitude}</p>
//     </div>
//   );
// };

// export default Test;
